(function () {
	'use strict';

	angular
		.module('uwAgenda.settings.grouppractice')
		.controller('WaitingRoomDetailController', WaitingRoomDetailControllerFn);
	
	WaitingRoomDetailControllerFn.$inject = [
        'waitingRoom',
        'Alert', 
        'GroupPracticeService',
        '$uibModalInstance',
		'$translate'];

	function WaitingRoomDetailControllerFn(
        waitingRoom,
        Alert, 
        GroupPracticeService,
        $uibModalInstance,
		$translate
    ) {
		var vm = this;
		
		vm.waitingRoom = waitingRoom;
		
		/* save current item */
		vm.save = function () {
			
			// save or update
			if (vm.waitingRoom.id > 0) {
				// update
				GroupPracticeService.updateWaitingRoom(
						vm.waitingRoom.groupPracticeId, 
						vm.waitingRoom.id,
						vm.waitingRoom
					).then(function() {
						Alert.success($translate.instant('waitingroom_updated'));
						$uibModalInstance.close();
					});				
			} 
			else {
				// save
				GroupPracticeService.createWaitingRoom(
					vm.waitingRoom.groupPracticeId, 
					vm.waitingRoom
				).then(function() {
					Alert.success($translate.instant('waitingroom_created'));
					$uibModalInstance.close();
				});				
			}
		};

		// close modal
		vm.abort = function () {
			$uibModalInstance.dismiss();
		};	
	}
})();
